/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ author: "engine" | "trainer" | "you" }} Plan_Draft_AuthorInputs */

const en_us2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Suggested by the app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Draft from your trainer`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`Your draft`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const pt_br2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Sugestão do app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Rascunho do seu personal`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`Seu rascunho`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const es_419_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Sugerencia de la app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Borrador de tu entrenador`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`Tu borrador`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const pt_pt2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Sugestão da app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Rascunho do teu treinador`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`O teu rascunho`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const fr_fr2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Suggéré par l'app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Brouillon de ton coach`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`Ton brouillon`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const de_de2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Vorschlag der App`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Entwurf deines Coachs`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`Dein Entwurf`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

const it_it2_plan_draft_author = /** @type {(inputs: Plan_Draft_AuthorInputs) => LocalizedString} */ (i) => {
	if (i?.author === "engine") return /** @type {LocalizedString} */ (`Suggerita dall'app`);
	if (i?.author === "trainer") return /** @type {LocalizedString} */ (`Bozza del tuo coach`);
	if (i?.author === "you") return /** @type {LocalizedString} */ (`La tua bozza`);
	return /** @type {LocalizedString} */ ("plan.draft_author");
};

/**
* | author | output |
* | --- | --- |
* | "engine" | "Suggested by the app" |
* | "trainer" | "Draft from your trainer" |
* | "you" | "Your draft" |
*
* @param {Plan_Draft_AuthorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_draft_author = /** @type {((inputs: Plan_Draft_AuthorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Draft_AuthorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_draft_author(inputs)
	if (locale === "es-419") return es_419_plan_draft_author(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_draft_author(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_draft_author(inputs)
	if (locale === "de-DE") return de_de2_plan_draft_author(inputs)
	if (locale === "it-IT") return it_it2_plan_draft_author(inputs)
	return en_us2_plan_draft_author(inputs)
});
export { plan_draft_author as "plan.draft_author" }